import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import OnboardingModal from "./onboardingModal";
import { useOnboardingContext } from "../../context/onboardingContext";

const OnboardingContainer = ({ children }) => {
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);
  const isAuthenticated = localStorage.getItem("autenticado") === "true";
  const location = useLocation();

  const { showOnboarding, isCheckingOnboarding, completeOnboarding } =
    useOnboardingContext();

  // Detectar si estamos en la página de onboarding
  const isOnboardingPage = location.pathname === "/onboarding";

  // Nota: Ya no verificamos automáticamente el onboarding aquí
  // El nuevo flujo es: Login -> verifica si necesita onboarding -> redirecciona a página de onboarding
  // Solo mostramos el modal si alguien manualmente activa showOnboarding Y NO estamos en la página de onboarding
  const shouldShowOnboarding =
    isAuthenticated &&
    infoAfiliado.codigoAfiliado &&
    !isCheckingOnboarding &&
    showOnboarding &&
    !isOnboardingPage; // Esta es la nueva condición para evitar conflictos

  return (
    <>
      {children}
      <OnboardingModal
        open={shouldShowOnboarding}
        onClose={completeOnboarding}
      />
    </>
  );
};

export default OnboardingContainer;
